import { z } from 'zod';

export const SSubscribeToChatwootMessage = z.object({
  command: z.string(),
  identifier: z.string(),
});
export type TSubscribeToChatwootMessage = z.infer<
  typeof SSubscribeToChatwootMessage
>;
